var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.project
    ? _c("app-project-info", {
        attrs: { project: _vm.project },
        on: {
          close: function ($event) {
            return _vm.onClose()
          },
          edit: function ($event) {
            return _vm.onEdit()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }